import 'normalize.css'
import React from 'react';

import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChakraProvider } from "@chakra-ui/react";
import MyCombineContextProvider from './YoutubeCompoDjango/contexts/CombineContext';
import reportWebVitals from "./reportWebVitals"
import * as serviceWorkerRegistration from "./serviceWorker"

/*

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
             
            <BrowserRouter>
            <React.StrictMode>
            <App />
            </React.StrictMode>
            </BrowserRouter>


);

*/

// Used this instead of ReactDom to prevent repetitions of react-simple-chatbot
import {render}from "react-dom"
render(
<MyCombineContextProvider>     {/*Auth System must exist before routing starts. Think of Auth as Infrastructure. Otherwise routing starts before it -Refresh Logic breaks*/}
<BrowserRouter>
<App />
</BrowserRouter>
</MyCombineContextProvider>
, document.getElementById("root"))


serviceWorkerRegistration.register()  // Enables PWA features (Progressive Web App - ie. Add to homescreen)